import Vue from 'vue'
import '@/config/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css';
// 导入弹框提示组件
import { Button, Form, FormItem, Input, Message, Container, Header, Aside,
  Main, Menu, Submenu, MenuItem, MenuItemGroup, Breadcrumb, BreadcrumbItem, Card, Row,
  Col, Table, TableColumn, Switch, Tooltip, Pagination, Dialog, MessageBox,
  Tag, Tree, Select, Option, Cascader, Alert, Tabs, TabPane, Steps, Step,
  CheckboxGroup, Checkbox, Upload, Timeline, TimelineItem, Link, Collapse, 
  CollapseItem, RadioGroup, Radio, RadioButton, InputNumber, Dropdown, DropdownMenu,
  DropdownItem, Popover,DatePicker,ButtonGroup,InfiniteScroll,Progress, Loading, Autocomplete } from 'element-ui'

Vue.use(InfiniteScroll);  
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(MenuItemGroup)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Steps)
Vue.use(Step)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Link)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(InputNumber)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(ButtonGroup)
Vue.use(Progress)
Vue.use(Loading)
Vue.use(Autocomplete)


// 将Message组件挂载到Vue的原型对象上，每个组件通过this访问$message
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
